import React  from 'react';
import PropTypes from 'prop-types';

const UpgradeIcon = (props) => {
  const { width, height } = props;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none" viewBox="0 0 14 17">
      <path fill="#AEB2BF" d="M4 13h6V7h4L7 0 0 7h4v6zm-4 2h14v2H0v-2z"/>
    </svg>
  );
};

UpgradeIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

UpgradeIcon.defaultProps = {
  width: 14,
  height: 17,
};

export default UpgradeIcon;
